import { IEmpresasResponse, IRespostaFuncaoEmpresa } from '../modelos/IEmpresa';
import { del, get, post, patch } from '../../api/api';
import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';

// Listar empresas
export const listarEmpresas = async () => {
  return await get<IRespostaFuncaoEmpresa<IEmpresasResponse>>(`/empresas`);
};

// Obtem empresa id
export const obtemEmpresa = async (empId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/empresas/${empId}`);
};

// Criar empresa
export const criarEmpresa = async (payload: any): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(`/empresas/cria-empresa`, payload);
};

// Atualizar empresa
export const atualizarEmpresa = async (
  empId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(`/empresas/${empId}/atualiza-empresa`, payload);
};

// Deletar empresa
export const deletarEmpresa = async (empId: string): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(`/empresas/${empId}/remove-empresa`);
};

// Atualiza Curva ABC
export const atualizaCurvaAbc = async (
  empId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(`/empresas/${empId}/atualiza-curva-abc`, payload);
};

// Atualiza Excesso de Estoque
export const atualizaExcessoEstoque = async (
  empId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(`/empresas/${empId}/atualiza-excesso-estoque`, {
    grupos: payload
  });
};

// Obtem Grupos Controle
export const obtemGruposControle = async (empId: string): Promise<IRespostaFuncao<any>> => {
  return await get<IRespostaFuncao<any>>(`/empresas/${empId}/grupos-controle`);
};

// Criar Grupo Controle
export const criarGrupoControle = async (
  empId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/empresas/${empId}/grupos-controle/cria-grupo-controle`,
    payload
  );
};

// Atualiza Grupo Controle
export const atualizaGrupoControle = async (
  empId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/empresas/${empId}/grupos-controle/atualiza-grupo-controle`,
    payload
  );
};

// Deleta Grupo Controle
export const deletarGrupoControle = async (
  empId: string,
  grupoId: string
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/empresas/${empId}/grupos-controle/remove-grupo-controle/${grupoId}`
  );
};

// Atualiza Arquitetura PBI Ativa
export const atualizaArquiteturaPbiAtiva = async (
  empId: string,
  chave: string
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(`/empresas/${empId}/atualiza-arquitetura-pbi-ativa`, {
    chave
  });
};

// Atualiza Parametros Embedded
export const atualizaParametrosEmbedded = async (
  empId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/empresas/${empId}/atualiza-parametros-embedded`,
    payload
  );
};

// Obtem paineis por empresa
export const obtemPaineisEmpresa = async (empId: string): Promise<IRespostaFuncao<any>> => {
  return await get<IRespostaFuncao<any>>(`/empresas/${empId}/obtem-paineis`);
};

// Atribui paineis empresa
export const atribuiPaineisEmpresa = async (
  empId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(`/empresas/${empId}/atribui-paineis`, {
    paineis: payload
  });
};
